import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import EventsList from './events/EventsList'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'

const NonComplianceBulkEditModal = props => {
  return (
    <ControlledModal width="48rem" {...props}>
      <ModalHeader />
      <Separator weight={6} />
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={6} />

      <FlexGrid justify="space-between" align="flex-start" paddingGutter={0.5} wrap>
        <FlexCol flex={6} wrapOn="sm">
          <EventsList />
        </FlexCol>
      </FlexGrid>
    </ControlledModal>
  )
}

export default NonComplianceBulkEditModal
